import React, { useContext, useState } from "react";
import { Tabs } from "@mantine/core";
import SettingsLayout from "./SettingsLayout";
import SwitchEmployerSetting from "./components/SwitchEmployerSetting";
import WhatsAppEmbeddedSignup from "./components/WhatsAppEmbeddedSignup";
import IntegrationsReportScheduling from "./components/IntegrationsReportScheduling";
import NotFound from "../../../common/pages/NotFound";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";
import { AuthContext } from "../../../providers/AuthProvider";
import { useEnabledFeatureFlag } from "../../../common/feature-flagging/FeatureFlagProvider";
import FeatureFlags from "../../../common/feature-flagging/FeatureFlags";
import UserAccessControlUtils, {
  FEATURE_INTEGRATIONS,
} from "../../../utils/UserAccessControlUtils";

const SettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { hasPermissions } = React.useContext(AccessPermissionContext);
  const auth = useContext(AuthContext);
  const isWhatsAppEmbeddedSignupEnabled = useEnabledFeatureFlag(
    FeatureFlags.WHATSAPP_EMBEDDED_SIGNUP
  );
  const isIntegrationsEnabled = UserAccessControlUtils.hasFeature(
    auth?.user_features ?? [],
    FEATURE_INTEGRATIONS
  );

  if (!hasPermissions) {
    return <NotFound />;
  }

  return (
    <SettingsLayout>
      <Tabs active={activeTab} onTabChange={setActiveTab}>
        <Tabs.Tab label="Switch Accounts">
          <SwitchEmployerSetting />
        </Tabs.Tab>
        {isIntegrationsEnabled && (
          <Tabs.Tab label="Integrations Report Scheduling">
            <IntegrationsReportScheduling />
          </Tabs.Tab>
        )}
        {isWhatsAppEmbeddedSignupEnabled && (
          <Tabs.Tab label="White Label">
            <WhatsAppEmbeddedSignup />
          </Tabs.Tab>
        )}
      </Tabs>
    </SettingsLayout>
  );
};

export default SettingsPage;
